import React from "react";
import "./spinner.css";

export default function LoadingSpinner({ contactSection, isWhiteColor=false }) {
  return (
    <div className={`${!contactSection ? "lds-roller" : isWhiteColor ? "lds-rollerContact whiteColor" : "lds-rollerContact"}`}>
      <div></div><div></div><div></div><div></div><div></div><div></div>
    </div>
  );
}